import { policyValueTableSection } from './policy-value-table-section'
import { legalDisclaimerSection } from './legal-disclaimer-section'

export const section = {
  legalDisclaimer: legalDisclaimerSection,
  policyValueTable: policyValueTableSection,
}
